import React from "react";
import { func } from "prop-types";
import moment from "moment";
import { scoreCardType } from "../../../../prop-types/scoreCardTypes";
import { FaCheck } from "react-icons/fa";
import { ImCross } from "react-icons/im";

const ScoreCardRow = ({ card, toggleDetails }) => (
  <React.Fragment>
    <tr>
      <td>
        {
          <a target="_blank" href={card.filename}>
            {card.name}
          </a>
        }
      </td>
      <td>
        {moment.utc(card.createDate).local().format("DD-MM-YYYY HH:mm:ss")}
      </td>
      <td>{card.createdByName}</td>
      <td>{card.targetType}</td>
      <td className="center" width={80}>
        {card.isValid ? (
          <FaCheck color="#0AD172" />
        ) : (
          <ImCross color="#FF0000" />
        )}
      </td>
    </tr>
  </React.Fragment>
);
ScoreCardRow.propTypes = {
  card: scoreCardType,
  toggleDetails: func.isRequired,
};

export default ScoreCardRow;



// WEBPACK FOOTER //
// ./src/features/score-card/components/score-cards-row/ScoreCardRow.jsx